<script>
export default {
  name: "RouteRedirect",
  created() {
    const target = this.$route.query.path || "/homePage";
    this.$router.replace(target);
  },
  render(h) {
    return h("div");
  },
};
</script>
